module.exports = __webpack_public_path__ + "img/banner3.25d76aab.jpg";